import { useEffect } from 'react';
import s from './InventoryActionsSheet.module.css';

type Action = 'inbound' | 'outbound' | 'adjust' | 'import';

const ACTIONS: { key: Action; title: string; detail: string }[] = [
  { key: 'inbound', title: '手工入库', detail: '零星补货、赠品、样品' },
  { key: 'outbound', title: '报损 / 盘亏出库', detail: '破损、丢失、盘点差异' },
  { key: 'adjust', title: '库存调整（盘点）', detail: '把账面数改成实际数' },
  { key: 'import', title: '导入期初库存', detail: '手机上适合看结果、改错行；大批量请在电脑上导' },
];

export function InventoryActionsSheet({ warehouseName, allowed, onSelect, onClose }: {
  warehouseName?: string;
  allowed: Record<Action, boolean>;
  onSelect: (action: Action) => void;
  onClose: () => void;
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return <div className={s.backdrop} onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className={s.sheet} role="dialog" aria-modal="true" aria-label="库存操作">
      <header><h2>库存操作</h2><small>{warehouseName ? `当前仓库：${warehouseName} · ` : ''}都会写库存流水</small></header>
      <div className={s.actions}>{ACTIONS.filter((item) => allowed[item.key]).map((item) => <button type="button" key={item.key} onClick={() => onSelect(item.key)}>
        <b>{item.title}</b><small>{item.detail}</small>
      </button>)}</div>
      <button type="button" className={s.cancel} onClick={onClose}>取消</button>
    </section>
  </div>;
}
